module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "List_of_Abbreviations"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('b', [_vm._v("List of Abbreviations")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "95%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("ADC")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Aide-de-Camp")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("ANZAC")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Australian and New Zealand Army Corps")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("C-in-C")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Commander-in-Chief")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("CIGS")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Chief of the Imperial General Staff")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("GHQ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("General Headquarters")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("GOC")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("General Officer Commanding")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("HE")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("High Explosive")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("HQ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Headquarters")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("KCB")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Knight Commander of the Bath")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("MEF")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Mediterranean Expeditionary Force")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("NATO")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("North Atlantic Treaty Organization")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("NCO")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Non Commissioned Officer")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("OC")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Officer Commanding")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("RN")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Royal Navy")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("RND")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Royal Naval Division")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("RNVR")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Royal Navy Volunteer Reserve")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("T.F.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Territorial Force")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("UK")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("United Kingdom")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("VD")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Venereal Disease")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("WO")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("War Office (UK)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_vm._v("2 i.c.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("Second in Command")])])])])])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28f63464","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_List_of_Abbreviations.vue
// module id = 72
// module chunks = 0